import React from "react"
import {Input} from "antd"
import styles from "./BaseInput.module.css"

const {Search} = Input

export function BaseSearchInput(props) {
    return <Search className={styles.searchInputWrap} enterButton {...props} />
}
